<template>
  <b-container>
    <b class="row">
      <b-col cols="12" md="12" lg="8">
        <b-row>
          <b-col cols="12" v-for="principal in entradasPrincipal" :key="principal.fecha">
            <v-card elevation="0" class="cardsHomeEntradas py-5 mx-0">
              <v-img class="white--text align-end" height="200px" :src="principal.portada">
                <div class="text-right p-3">
                  <v-icon class="rippleBlog">mdi-calendar</v-icon>
                  {{principal.fecha}}
                </div>
              </v-img>

              <v-card-text class="m-0 p-0">
                <div class="py-3 etiquetaInner text-uppercase">
                  <a :href="'categoria/'+principal.categoria">{{principal.categoria}}</a>
                </div>

                <div class="pb-5 tituloInner">Titulo</div>

                <div
                  class="pb-5"
                >Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea laborum aspernatur vero labore aliquid hic eaque vel.</div>
              </v-card-text>
              <v-card-actions class="p-0">
                <v-btn text class="violeta text-bold" :href="principal.href">
                  Leer más
                  <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </b-col>
          <b-col cols="12" sm="12" md="6" v-for="entrada in entradasPortada" :key="entrada.portada">
            <v-card elevation="0" class="cardsHomeEntradas py-5 mx-0">
              <v-img class="white--text align-end" height="200px" :src="entrada.portada">
                <div class="text-right p-3">
                  <v-icon class="rippleBlog">mdi-calendar</v-icon>
                  {{entrada.fecha}}
                </div>
              </v-img>

              <v-card-text class="m-0 p-0">
                <div class="py-3 etiquetaInner text-uppercase">{{entrada.categoria}}</div>

                <div class="pb-5 tituloInner">{{entrada.titulo}}</div>

                <div
                  class="pb-5"
                >Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea laborum aspernatur vero labore aliquid hic eaque vel.</div>
              </v-card-text>
              <v-card-actions class="p-0">
                <v-btn text class="violeta text-bold">
                  Leer más
                  <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </b-col>
          <b-col cols="12">
            <div class="text-center">
              <v-pagination v-model="page" :length="4"></v-pagination>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="12" lg="4">
        <ColumnaDer />
      </b-col>
    </b>
  </b-container>
</template>

<script>
import ColumnaDer from "../components/ColumnaDer";

export default {
  name: "EntradasHome",
  components: {
    ColumnaDer
  },

  data: () => ({
    page: 1
  }),

  async mounted() {
    await this.$store.dispatch("entradas/listarPrincipal");
    await this.$store.dispatch("entradas/listarEntradas");
    await this.$store.dispatch("categorias/listarCategorias");
    this.entradasPortada.shift();
    this.$store.dispatch("categorias/listarNumCategorias", this.categorias);
  },
  computed: {
    entradasPrincipal() {
      return this.$store.getters["entradas/verPrincipal"];
    },
    entradasPortada() {
      return this.$store.getters["entradas/verEntradas"];
    },
    categorias() {
      return this.$store.getters["categorias/verCategorias"];
    }
  }
};
</script>
